export function mergeTags(listaTags, tags) {
  if (!tags) return;
  // Cria um objeto para mapear os _id de tags com checked no array tags
  let checkedMap = new Map(tags.map(tag => [tag._id, true]));

  // Cria um novo array baseado em listaTags
  let newArray = listaTags.map(tag => {
    return {
      ...tag,
      checked: checkedMap.has(tag._id) ? true : false
    };
  });

  return newArray;
}


export function groupMessagesByDate(messages) {
  return messages.reduce((groups, message) => {
    // Usar a propriedade 't' que é usada consistentemente em todo o código
    const timestamp = message.t || message.timestamp || 0;
    const date = new Date(timestamp * 1000);
    const dateStr = date.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });

    if (!groups[dateStr]) {
      groups[dateStr] = [];
    }
    groups[dateStr].push(message);
    return groups;
  }, {});
}


export const validaVCard = message => {
  let array = message.body.split("\n");
  let numero = "";
  let contact = "";
  for (let index = 0; index < array.length; index++) {
    const v = array[index];
    let values = v.split(":");
    for (let ind = 0; ind < values.length; ind++) {
      if (values[ind].indexOf("+") !== -1) {
        numero = values[ind]
      }
      if (values[ind].indexOf("FN") !== -1) {
        contact = values[ind + 1];
      }
    }
  }
}



export function checkMsgToInsert(message) {
  // varificar mensagem para inserir no historico
  switch (message.type) {
    case "chat":
      return message.body;
    case "image":
      return "📷 Imagem";
    case "ptt":
      return "🎤 Áudio";
    case "sticker":
      return "🎨 Adesivo";
    case "document":
      return "📄 Documento";
    case "video":
      return "🎥 Vídeo";
    case "location":
      return "📍 Localização";
    case "vcard":
      return "👤 Contato";
    case "url":
      return "🔗 Link";
    case "call_log":
      return "📞 Chamada";
    case "gp2":
      return "";
    default:
      return "";
  }
}

export function removeHttpPrefix(url) {
  if (!url) return '';
  return url.replace(/https?:\/\//g, '');
}